import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from '../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../ng2-bootstrap-modal/dialog.service';
import {Product} from "../../../../websites/website/product";

export interface IConfirmDialogData {
  header: string;
  message: string;
  singleSiteButtonText: string;
  multisiteButtonText: string;
  product?: Product;
}
@Component({
    selector: 'db-multisite-action-confirm-dialog',
    templateUrl: './multisite-action-confirm-dialog.component.html',
    styleUrls: ['./multisite-action-confirm-dialog.component.scss'],
    standalone: false
})
export class MultisiteActionConfirmDialogComponent extends DialogComponent<IConfirmDialogData, string|boolean> implements OnInit, IConfirmDialogData {

  @Input() header: string;
  @Input() message: string;
  @Input() singleSiteButtonText: string;
  @Input() multisiteButtonText: string;
  @Input() product?: Product;

  constructor(
    private _dialogService: DialogService
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
  }


  public confirm(actionType, actionText): void {
    actionText !== 'Later';
    this.result = actionType;
    this.close();
  }

}
